<template>
    <el-popover
        ref="payroll-clone-popover"
        placement="top"
        title=""
        width="320"
        trigger="manual"
        v-model="isCloneFormVisible"
        :visible-arrow="false"
        popper-class="clone-popover"
        v-on-clickaway="handleClickAway"
    >
        <div v-loading="loadingCloneForm">
            <div class="clone-form">
                <div class="title">
                    Клонирование зарплатной ведомости
                </div>
                <div>
                    Откуда
                </div>
                <el-select
                    v-model="source.year"
                    placement="bottom"
                    popper-class="popper-dropdown"
                    placeholder="Год"
                    size="mini"
                >
                    <el-option v-for="item in Object.keys(existedReportDates)" :key="item" :label="item" :value="item" />
                </el-select>
                <el-select
                    v-model="source.month"
                    placement="bottom"
                    popper-class="popper-dropdown"
                    placeholder="Месяц"
                    size="mini"
                    no-data-text="Выберите год"
                >
                    <el-option v-for="item in existedReportDates[source.year]" :key="item" :label="item" :value="item" />
                </el-select>
                <div>Куда</div>
                <el-select
                    v-model="target.year"
                    placement="bottom"
                    popper-class="popper-dropdown"
                    placeholder="Год"
                    size="mini"
                >
                    <el-option v-for="item in localReferences.yearsList" :key="item" :label="item" :value="item" />
                </el-select>
                <el-select
                    v-model="target.month"
                    placement="bottom"
                    popper-class="popper-dropdown"
                    placeholder="Месяц"
                    size="mini"
                >
                    <el-option v-for="item in localReferences.monthsList" :key="item" :label="item" :value="item" />
                </el-select>
                <el-button
                    type="warning"
                    @click="clonePayrolls"
                    :class="['confirm-button', { 'red-bg': isSelectedPeriodExist, 'grey2-bg': isDisabledConfirmButton}]"
                    :disabled="isDisabledConfirmButton"
                >
                    {{ isSelectedPeriodExist ? 'Подтвердить удаление' : 'Клонировать' }}
                </el-button>
                <el-button type="warning" @click="hideForm" class="cancel-button">
                    Отмена
                </el-button>
                <div class="warning-text" v-if="isSelectedPeriodExist">
                    Зарплатная ведомость на {{ target.month }}-{{ target.year }} существует.
                    Все записи ведомости этого периода будут удалены.
                </div>
            </div>
        </div>
    </el-popover>
</template>

<script>
import moment from 'moment';
import localReferences from '@/helpers/localReferences';
import { mixin as clickaway } from 'vue-clickaway';
import '@/assets/styles/expenses.scss';

const initialSource = {
    year: null,
    month: null
};
const initialTarget = {
    year: moment().format('YYYY'),
    month: moment().add(1, 'month').format('MM')
};

export default {
    name: 'PayrollCloneForm',
    mixins: [
        clickaway
    ],
    data() {
        return {
            localReferences,
            isCloneFormVisible: false,
            loadingCloneForm: false,
            existedReportDates: {},
            source: {},
            target: {}
        };
    },
    props: {
        isVisible: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isSelectedPeriodExist() {
            return this.source.year &&
                this.source.month &&
                Object.keys(this.existedReportDates).includes(this.target.year) &&
                this.existedReportDates[this.target.year].includes(this.target.month);
        },
        isDisabledConfirmButton() {
            return !this.source.year || !this.source.month || !this.target.year || !this.target.month;
        }
    },
    methods: {
        handleClickAway(event) {
            if (this.isCloneFormVisible && !event.target.className.split(' ').includes('clone-form-action')) {
                this.hideForm();
            }
        },
        hideForm() {
            this.isCloneFormVisible = false;
            this.$emit('hideForm');
        },
        async clonePayrolls() {
            try {
                this.loadingCloneForm = true;
                const data = {
                    sourceReportDate: `${this.source.year}-${this.source.month}-01`,
                    targetReportDate: `${this.target.year}-${this.target.month}-01`,
                    isToDeleteTargetPayrolls: this.isSelectedPeriodExist
                };
                const response = await this.$store.dispatch('salary/clonePayrolls', data);
                this.$notify({ title: 'Успешно', message: `Склонировано ${response.clonedPayrollsCount} записей`, type: 'success' });
                this.hideForm();
                this.$emit('refreshList');
            } catch (error) {
                console.log(error.message);
            } finally {
                this.loadingCloneForm = false;
            }
        },
        async getExistedReportDatesInfo() {
            try {
                this.loadingCloneForm = true;
                this.existedReportDates = await this.$store.dispatch('salary/getExistedReportDatesInfo');
            } catch (error) {
                console.log(error.message);
            } finally {
                this.loadingCloneForm = false;
            }
        }
    },
    watch: {
        isVisible(value) {
            this.isCloneFormVisible = value;
            if (this.isCloneFormVisible) {
                this.source = Object.assign({}, initialSource);
                this.target = Object.assign({}, initialTarget);
                this.getExistedReportDatesInfo();
            }
        }
    }
};
</script>
